<script setup lang="ts">
import { t } from "@/plugins/i18n";

const { exportType, size = "default", density = "comfortable" } = defineProps<{
	exportType: string;
	size?: "x-small" | "small" | "default" | "large" | "x-large";
	density?: "default" | "comfortable" | "compact";
}>();

const exportTypeColors = new Map<string, string>([
	["data_table", "info"],
	["segment", "#E69F00"],
	["dashboard", "success"],
	["graph_data", "#800080"],
	["underlying_data", "warning"],
	["integration_data", "indigo"],
	["capacity_data", "teal"],
]);

function getExportTypeColor(name_clean: string) {
	if (!exportTypeColors.has(name_clean)) return "#607D8B";
	return exportTypeColors.get(name_clean);
}
</script>

<template>
	<v-chip
		:color="getExportTypeColor(exportType)"
		:size="size"
		:density="density"
		label
	>
		{{ t(`scheduler.export_types.${exportType}`) }}
	</v-chip>
</template>

<style scoped lang="scss"></style>
